import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { acdSummary } from 'src/app/interfaces/dashboard';
import { EmdmIcons } from 'src/app/services/appicons.service';
import { AcdService } from 'src/app/services/dashboard.service';
import { mwoService } from 'src/app/services/mwo.service';
import { commonService } from 'src/app/services/common.service';
import { DataService } from '@progress/kendo-angular-dropdowns/common/data.service';
//import { RequestPriority } from '../../models/enums/request-priority.enum';
import { getAcdEnvConfig } from 'src/app/configs/acd-env.config';
@Component({
  selector: 'app-acd-summary',
  templateUrl: './acd-summary.component.html',
  styleUrl: './acd-summary.component.scss'
})
export class AcdSummaryComponent {
  facheck = this.iconPacks.FaCheck;
  public crNo!: number;

  popupShow = false;
  popupTitle = "Show Obselute Items";
  popupHeight = 600;
  popupWidth = 800;
  showSubmitBtn = false;
  requestPriorityid = 0;
  crDetails: any = {};
  specialist = false;
  isBuild = false;
 // summaryType = getSummaryTypeEnum();
  acdEnv = getAcdEnvConfig(); 
  summaryType = this.acdEnv.summaryType; 
  @Input() set setCRNo(crNo: number) {
    if (crNo > 0 && this.crNo != crNo) {
      this.crNo = crNo;
      this.acdSummary();
    }
  }
  @Input() set setCrDetails(crDetails: any) {
    if (crDetails) {
      this.crDetails = crDetails;
      this.setCrInfo();
    }
  }

  setCrInfo() {
    this.isBuild = (this.crDetails.status == 'Build');
    let priority = this.crDetails.priority.toLocaleLowerCase();
    if (priority) {
      //this.requestPriorityid = priority == 'urgent' ? RequestPriority.urgent : (priority == 'high' ? RequestPriority.high : RequestPriority.medium);
      this.requestPriorityid = priority == 'urgent' ? this.acdEnv.requestPriority.urgent : (priority == 'high' ? this.acdEnv.requestPriority.high : this.acdEnv.requestPriority.medium);
    }
  }

  public acdsummarydata: Array<acdSummary> = [];
  constructor(private route: ActivatedRoute, private router: Router, private mwoservice: mwoService, private iconPacks: EmdmIcons,
    private acdservice: AcdService, private commonService: commonService) {
  }

  ngOnInit() {
    this.commonService.isSpecialist.subscribe((x: boolean) => {
      this.specialist = x;
    })
    this.commonService.isAdmin.subscribe((x: boolean) => {
      this.specialist = x || this.specialist;
    })
  }

  acdSummary() {
    this.mwoservice.AcdSummary(this.crNo).subscribe((data) => {
      this.acdsummarydata = data;
      if (data.length > 0 && this.isBuild) {
        this.showSubmitBtn = true;
      }
    })
  }

  submitAcdRequest() {
    let flagReceived = confirm("Are you sure you want to submit change request #" + this.crNo);
    if (flagReceived) {
      this.acdservice.submitAcdSummary(this.crNo, this.requestPriorityid).subscribe((data) => {
        let message = "Change request #" + this.crNo + " successfully submitted."
        this.commonService.showNotificationMessage(message, 'success', 'center', 200, false);
        this.router.navigateByUrl('/dashboard');
      })
    }
  }
  navigateToEditRequest(id: number) {
    if (id > 0) {
      if (id == this.summaryType['EPL']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=EPL&step=Edit`);
      }
      else if (id == this.summaryType['EQM']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=EPL&step=Edit`);
      }
      else if (id == this.summaryType['JobPlanLabor'] || id == this.summaryType['JobPlanParts']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=JobPlan&step=Edit`);
      }
      else if (id == this.summaryType['PMRoutes'] || id == this.summaryType['PMAssociations'] || id == this.summaryType['PreventativeMaintenance']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=PM&step=Edit`);
      }
      else if (id == this.summaryType['ObsoleteItems']) {
        this.popupShow = true;
      } else if (id == this.summaryType['MWOHeader']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=MWO&step=Edit`);
      }
    }
  }
  navigateToBuilds(id: number) {
    if (id > 0) {
      if (id == this.summaryType['EPL']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=EPL&step=Build`);
      }
      else if (id == this.summaryType['EQM']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=EPL&step=Build`);
      }
      else if (id == this.summaryType['JobPlanLabor'] || id == this.summaryType['JobPlanParts']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=JobPlan&step=Build`);
      }
      else if (id == this.summaryType['PMRoutes'] || id == this.summaryType['PMAssociations'] || id == this.summaryType['PreventativeMaintenance']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=PM&step=Build`);
      }
      else if (id == this.summaryType['ObsoleteItems']) {
        this.popupShow = true;
      } else if (id == this.summaryType['MWOHeader']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=MWO&step=Build`);

      }
    }
  }

  closeActionPopup(event: any) {
    this.popupTitle = "";
    this.popupShow = false;
    this.acdSummary();
  }
}
